import { Button } from '@wayste/sour-ui';
import { FaDumpsterFire } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { routes } from '../utils';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex h-lvh flex-col items-center justify-center gap-4">
            <FaDumpsterFire className="text-primary-400 size-24" />
            <h1 className="text-6xl font-bold text-gray-800">404</h1>
            <h2 className="text-2xl font-semibold text-gray-600">Page Not Found</h2>
            <p className="text-gray-500">Oops! Looks like this page has been trashed.</p>
            <Button className="btn-primary" onClick={() => navigate(routes.orders.list)}>
                Go Home
            </Button>
        </div>
    );
};

export default NotFound;
